export class AppointmentTypesToExclude {
  // FIXME: Exclude Between Type Till Ready For Production
	static list = ['a.s.a.p', 'any time', 'between'];
}
